module.exports = __webpack_public_path__ + "static/GrayGminaZblewo-179e224e1b3d802700bbbe38a8cd91d7.svg";